var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"financial-entities"}},[_c('GenericPage',[_c('template',{slot:"breadcrumb-items"},[_c('li',{staticClass:"active bold"},[_vm._v("Buró de Entidades Financieras")])]),_c('template',{slot:"title"},[_vm._v(" Buró de Entidades Financieras. ")]),_c('template',{slot:"body"},[_c('FEArea1')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }